import React, { FC } from 'react'
import clsx from 'clsx'
import Subtitle from 'src/components/ui/Subtitle'
import H1 from 'src/components/ui/title/H1'
import H2 from 'src/components/ui/title/H2'
import { ISectionHeaderTitleProps } from './types'
import SectionHeaderLinkCta from './SectionHeaderLinkCta'

export const SectionHeaderTitle: FC<ISectionHeaderTitleProps> = ({
  subtitle,
  titlePart1,
  titlePart2,
  titlePart3,
  isH1 = false,
  theme = 'light',
  isLinkCta = false,
  linkText,
  linkUrl,
  onCtaClick,
  contentOnly = false,
  subtitleRef,
  titleRef,
  ctaRef,
  className = '',
}) => {
  if (contentOnly) return null

  const renderHeading = (headingClassName = 'opacity-0') => {
    if (isH1) {
      return (
        <H1
          ref={titleRef}
          firstPart={titlePart1}
          secondPart={titlePart2}
          thirdPart={titlePart3}
          theme={theme}
          className={headingClassName}
        />
      )
    }
    return (
      <H2
        ref={titleRef}
        firstPart={titlePart1}
        secondPart={titlePart2}
        thirdPart={titlePart3}
        theme={theme}
        className={headingClassName}
      />
    )
  }

  return (
    <div className={clsx('w-full flex flex-col gap-base md:gap-semi-large lg:gap-small', className)}>
      {subtitle && (
        <Subtitle ref={subtitleRef} className="mb-0 opacity-0">
          {subtitle}
        </Subtitle>
      )}

      {isLinkCta && linkText && linkUrl ? (
        <div className="w-full flex flex-col md:flex-row md:items-end md:justify-between gap-y-4 gap-x-8">
          <div className="flex-1">
            {renderHeading(contentOnly ? '' : 'opacity-0')}
          </div>
          <SectionHeaderLinkCta
            ctaRef={ctaRef}
            linkUrl={linkUrl}
            linkText={linkText}
            onCtaClick={onCtaClick}
            className={clsx('pb-1 md:pb-2.5', contentOnly ? '' : 'opacity-0')}
          />
        </div>
      ) : (
        renderHeading('opacity-0')
      )}
    </div>
  )
}

export default SectionHeaderTitle
